import React from "react";
import './identidades.scss'
import img1 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-1.jpg'
import img2 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-2.jpg'
import img3 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-3.jpg'
import img4 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-4.jpg'
import img5 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-5.jpg'
import img6 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-6.jpg'
import img7 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-7.jpg'
import img8 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-8.jpg'
import img9 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-9.jpg'
import img10 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-10.jpg'
import img11 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-11.jpg'
import img12 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-12.jpg'
import img13 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-13.jpg'
import img14 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-14.jpg'
import img15 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-15.jpg'
import img16 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-16.jpg'
import img17 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-17.jpg'
import img18 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-18.jpg'
import img19 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-19.jpg'
import img20 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-20.jpg'
import img21 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-21.jpg'
import img22 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-22.jpg'
import img23 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-23.jpg'
import img24 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-24.jpg'
import img25 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-25.jpg'
import img26 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-26.jpg'
import img27 from '../../images/identidades/casa-giacomo/manual-de-marca-casa-giacomo-27.jpg'


function CasaGiacomo() {

    const images = [
        img1, img2, img3, img4, img5, img6, img7, img8, img9,
        img10, img11, img12, img13, img14, img15, img16,
        img17, img18, img19, img20, img21, img22, img23,
        img24, img25, img26, img27
    ]

    return (
        <div className="presentation">
            {
                images.map((element) => {
                    return <img src={element} alt="Manual de marca - Casa Giacomo" />
                })
            }

        </div>
    );
}

export default CasaGiacomo;